/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchStreamErrorCode } from './SearchStreamErrorCode';
import {
    SearchStreamErrorCodeFromJSON,
    SearchStreamErrorCodeFromJSONTyped,
    SearchStreamErrorCodeToJSON,
    SearchStreamErrorCodeToJSONTyped,
} from './SearchStreamErrorCode';

/**
 * Terminal error event. The stream closes immediately after this fires.
 * `code` enumerates the failure mode for client-side handling. Reuses
 * `SearchStreamErrorCode`.
 * 
 * @export
 * @interface VehicleStreamError
 */
export interface VehicleStreamError {
    /**
     * 
     * @type {string}
     * @memberof VehicleStreamError
     */
    type: VehicleStreamErrorTypeEnum;
    /**
     * 
     * @type {SearchStreamErrorCode}
     * @memberof VehicleStreamError
     */
    code: SearchStreamErrorCode;
    /**
     * 
     * @type {string}
     * @memberof VehicleStreamError
     */
    message: string;
}


/**
 * @export
 */
export const VehicleStreamErrorTypeEnum = {
    Error: 'error'
} as const;
export type VehicleStreamErrorTypeEnum = typeof VehicleStreamErrorTypeEnum[keyof typeof VehicleStreamErrorTypeEnum];


/**
 * Check if a given object implements the VehicleStreamError interface.
 */
export function instanceOfVehicleStreamError(value: object): value is VehicleStreamError {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function VehicleStreamErrorFromJSON(json: any): VehicleStreamError {
    return VehicleStreamErrorFromJSONTyped(json, false);
}

export function VehicleStreamErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleStreamError {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'code': SearchStreamErrorCodeFromJSON(json['code']),
        'message': json['message'],
    };
}

export function VehicleStreamErrorToJSON(json: any): VehicleStreamError {
    return VehicleStreamErrorToJSONTyped(json, false);
}

export function VehicleStreamErrorToJSONTyped(value?: VehicleStreamError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'code': SearchStreamErrorCodeToJSON(value['code']),
        'message': value['message'],
    };
}

